<h1 mat-dialog-title class="confirmationfont">{{data.title}}</h1>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button class="yesButton" mat-button (click)="ok()">Ok</button>
</mat-dialog-actions>